import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import { getConsent, openConsent } from "../lib/consent";
import { L3 } from "../lib/publicI18n";
import { pickLang } from "../lib/langs";

export default function MapEmbed({ q, src, zoom = 15, className = "", testid = "map-embed" }) {
  const [ok, setOk] = useState(() => !!getConsent()?.maps);
  useEffect(() => {
    const f = (e) => setOk(!!e.detail?.maps);
    window.addEventListener("amalfi-consent", f);
    return () => window.removeEventListener("amalfi-consent", f);
  }, []);
  const link = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
  if (ok) return <iframe title="Google Maps" loading="lazy" className={className} src={src || `https://maps.google.com/maps?q=${encodeURIComponent(q)}&z=${zoom}&output=embed`} data-testid={testid} />;
  return (
    <div className={`${className} flex flex-col items-center justify-center gap-2 bg-[#F7F2E9] text-sm text-[#1B2A4A] p-4 text-center`} data-testid={`${testid}-blocked`}>
      <MapPin size={20} />
      <a href={link} target="_blank" rel="noopener noreferrer" className="underline font-semibold">{L3(pickLang("en"), "Apri in Google Maps", "Open in Google Maps")}</a>
      <button type="button" onClick={openConsent} className="text-xs underline opacity-80">{L3(pickLang("en"), "Consenti le mappe integrate", "Allow embedded maps")}</button>
    </div>
  );
}
